import { Reference } from '@apollo/client';

import useMutationWithValidation from '@hooks/useMutationWithValidation';
import {
  GetJourneyWithPlanQuery,
  WorksheetDestroyDocument,
  WorksheetDestroyMutation,
  WorksheetDestroyMutationVariables
} from '@typing/Generated';
import { getAllGoals } from '@utils/modelUtils';

const useDestroyWorksheet = (journey: GetJourneyWithPlanQuery['journey']) => {
  const [destroyWorksheet] = useMutationWithValidation<WorksheetDestroyMutation, WorksheetDestroyMutationVariables>(
    WorksheetDestroyDocument,
    'worksheet',
    {
      update: (store, { data }) => {
        if (data?.worksheetDestroy?.id) {
          store.modify({
            fields: {
              worksheets(cachedRefs: readonly Reference[], { readField }) {
                return cachedRefs.filter(ref => data.worksheetDestroy?.id !== readField('id', ref));
              }
            },
            id: store.identify({ ...journey })
          });

          const goals = getAllGoals(journey).filter(goal =>
            goal.worksheets.some(ai => ai.id === data.worksheetDestroy?.id)
          );

          journey.goals.filter(goal => goal.worksheets.some(ai => ai.id === data.worksheetDestroy?.id)) ??
            goals.map(goal => {
              store.modify({
                fields: {
                  worksheets(cachedRefs: readonly Reference[], { readField }) {
                    return cachedRefs.filter(ref => data.worksheetDestroy?.id !== readField('id', ref));
                  }
                },
                id: store.identify({ ...goal })
              });
            });

          const fileResourceId = journey.worksheets.find(worksheet => worksheet.id === data.worksheetDestroy?.id)
            ?.fileResource?.id;

          if (fileResourceId) {
            store.modify({
              fields: {
                fileResources(cachedRefs: readonly Reference[], { readField }) {
                  return cachedRefs.filter(ref => fileResourceId !== readField('id', ref));
                }
              },
              id: store.identify({ ...journey })
            });
          }
        }
      }
    }
  );

  return destroyWorksheet;
};

export default useDestroyWorksheet;
